import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoggerModule } from 'ngx-logger';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ReactiveFormsModule } from "@angular/forms";
import { PetszelSharedModule } from "../../../petszel-shared/src/lib/petszel-shared.module";
import { NgbDateAdapter, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { CustomAdapter, CustomDateParserFormatter } from "./date-picker-adapter/date-picker.adapter";
import { setLicenseKey } from "survey-core";
import { AuthInterceptor } from './service/auth-interceptor';
import { TermsOfServiceModalComponent } from './components/terms-of-service-modal/terms-of-service-modal.component';
import { environment } from '../environments/environment';
import { PopupService, SurveyModule } from 'survey-angular-ui';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { authReducer } from './store/auth/auth.reducer';
import { AuthEffects } from './store/auth/auth.effects';
import { permissionsReducer } from "./store/user/permissions/permissions.reducer";
import { featureFlagAdopterHubReducer } from "./store/user/feature-flag-adopter-hub/feature-flag-adopter-hub.reducer";
import { FeatureFlagAdopterHubEffects } from "./store/user/feature-flag-adopter-hub/feature-flag-adopter-hub.effects";
import { shelterSitesReducer } from "./store/shelter/sites/shelter-sites.reducer";

setLicenseKey(
  "YzNkNDg3NTQtOGQ0Ny00Y2U1LWFkNzgtZTgzOTgzMmY5NTZjOzE9MjAyNS0wMy0xNCwyPTIwMjUtMDMtMTQsND0yMDI1LTAzLTE0"
);

@NgModule({ declarations: [
        AppComponent,
        ChangePasswordComponent,
        TermsOfServiceModalComponent,
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        AppRoutingModule,
        RouterModule,
        CommonModule,
        SurveyModule,
        LoggerModule.forRoot({
            level: environment.logger.level,
            serverLogLevel: environment.logger.serverLogLevel,
            disableConsoleLogging: environment.logger.disableConsoleLogging
        }),
        ReactiveFormsModule,
        PetszelSharedModule,
        StoreModule.forRoot({
          auth: authReducer,
          permissions: permissionsReducer,
          featureFlagAdopterHub: featureFlagAdopterHubReducer,
          shelterSites: shelterSitesReducer
        }),
        EffectsModule.forRoot([
          AuthEffects,
          FeatureFlagAdopterHubEffects
        ]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production
        })
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        PopupService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }



